import { curry } from 'ramda';
import makeTemplateGetter from '@aspectus/resource-template-url-getter';
import {
  defaultDataTransformer,
  jsonTransformer,
} from '@packages/resource-commons';

const filtersGetterBase = makeTemplateGetter('{;filters*}');
const filtersGetter = parameters => filtersGetterBase(parameters).slice(1) || null

const partGetter = (name, prefix) => {
  const base = makeTemplateGetter(`${prefix}{/${name}}`);
  return parameters => {
    const result = base(parameters);
    return result === prefix ? null : result;
  };
};

const pageGetter = partGetter('page', 'page');
const labelGetter = makeTemplateGetter('{label}');
const categoryGetter = makeTemplateGetter('{category}');
const categoryGPGetter = makeTemplateGetter('{?category}');
const getParametersGetter = makeTemplateGetter('{?limit,offset}');

const order_map = {
  label: labelGetter,
  category: categoryGetter,
  categoryGP: categoryGPGetter,
  filters: filtersGetter,
  pagination_offset: getParametersGetter,
  page: pageGetter,
}

const initOrder = {
  path: [
    'prefix',
    'filters',
  ],
}

export const urlGetter = curry(([prefix, postfix], { path, query = [] }, p) => {
  const base = { prefix, postfix }
  const path_parts = path.reduce((acc, x, i) => {
    acc[i] = order_map[x] ? order_map[x](p) : base[x]
    return acc
  }, Array.from({ length: path.length }, () => null))
  const query_params = query.reduce((acc, x) => {
    acc.push(order_map[x](p))
    return acc
  }, [])
  return (`${path_parts.filter(x => x !== null).join('/')}/`).replace(/\/\/\//img, '/').replace(/%2C/g, ',').replace(/\/\//img, '/') + query_params.join('');
});

export const friendlyUrlGenerator = (url, resource, order = initOrder) => resource
  .url(urlGetter(url, order))
  .transform(jsonTransformer)
  .transform(defaultDataTransformer)
